import { render } from "./RegisterSadmin.vue?vue&type=template&id=b951a574&scoped=true"
import script from "./RegisterSadmin.vue?vue&type=script&lang=js"
export * from "./RegisterSadmin.vue?vue&type=script&lang=js"

import "./RegisterSadmin.vue?vue&type=style&index=0&id=b951a574&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b951a574"]])

export default __exports__